<div class="affdepots-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a [routerLink]="['/utilisateur/espace/busnes/activite', safeName, accountNumber]" class="crumb-link">
        <i class="bi bi-arrow-left"></i> Retour activite business
      </a>
      <span class="crumb-current">Dépôts professionnels</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Compte pro</p>
        <h1>{{bDescription}}</h1>
        <p class="lead">Liste des dépôts effectués sur le compte {{accountNumber}}.</p>
      </div>
      <div class="pill-row d-none d-sm-flex">
        <span class="pill pill-strong">Dépôts</span>
        <span class="pill">Suivi & contrôle</span>
      </div>
    </div>
  </div>

  <div class="card-glass p-3">
    <p class="eyebrow mb-1">Dépôts</p>
    <div
      class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mb-3">
      <h4 class="mb-0">Historique</h4>
      <div class="d-flex align-items-center gap-2 w-100 w-sm-auto">
        <label class="text-muted mb-0" for="monthSelectDepots">Mois</label>
        <select id="monthSelectDepots"
          class="form-select form-select-sm bg-dark text-light border-secondary w-100 w-sm-auto"
          [(ngModel)]="selectedMonth" (change)="applyMonthFilter(selectedMonth)">
          <option *ngFor="let m of monthOptions" [value]="m.value">{{ m.label | titlecase }}</option>
        </select>
      </div>
    </div>
    <!--<p class="text-muted small mb-3">Par défaut seules les opérations du mois en cours sont affichées. Choisissez un mois
      précédent pour afficher les dépôts déjà récupérés.</p>-->
    <div class="table-responsive">
      <table class="table table-borderless align-middle text-light">
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th>Montant</th>
            <th>Caissier</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of depotslist">
            <td>{{a.id }}</td>
            <td>{{a.date| date:'dd/MM/yy H:mm:ss' }}</td>
            <td>{{a.montan | currency:a.sigleMonnaie }}</td>
            <td>{{a.caissier }}</td>
          </tr>
          <tr *ngIf="!depotslist || depotslist.length === 0">
            <td colspan="4" class="text-center text-muted">Aucun dépôt pour l’instant.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
